import { render, staticRenderFns } from "./DwdcqkdjEdit.vue?vue&type=template&id=ed206274"
import script from "./DwdcqkdjEdit.vue?vue&type=script&lang=js"
export * from "./DwdcqkdjEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports